





















import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SimpleCard as Card } from '../../blocks';
import { Warning, Header, ListGrid } from '../../components';
import { RouteParsedMixin } from '../../mixins';
import { routeParse } from '@/pages/profile/utils';

import {
  ACTION_INIT,
  ACTION_REMOVE,
  Item,
  Items,
  NAME,
} from '@/store/deferred';

const deferred = namespace(NAME);

@Component({
  components: {
    Header,
    ListGrid,
    Card,
    Warning,
  },
  metaInfo: () => ({
    title: 'Избранное',
  }),
})
export default class Favorite extends Mixins(RouteParsedMixin) {
  // Vuex
  @deferred.State items: Items;
  @deferred.Action(ACTION_INIT) init: () => Promise<void>;
  @deferred.Action(ACTION_REMOVE) remove: (id: Item['id']) => Promise<void>;

  // Computed
  get hasItems() {
    const { items } = this;
    return items && items.length > 0;
  }

  // Hooks
  mounted() {
    this.init();
  }

  // Methods
  getActualParse(val: Item) {
    if (val.isActivity) {
      return this.routerActivity(val);
    } else {
      return this.parse(val);
    }
  }

  routerActivity(val: Item) {
    const id = val.id;
    const name = 'activity';
    const router = routeParse(id, '', name);
    return router;
  }

  onDelete(index: number) {
    const { items } = this;
    if (items[index]) {
      this.remove(items[index].id);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/favorite/Favorite.vue